import { render, staticRenderFns } from "./transformView.vue?vue&type=template&id=3de10ca8&scoped=true"
import script from "./transformView.vue?vue&type=script&lang=js"
export * from "./transformView.vue?vue&type=script&lang=js"
import style0 from "./transformView.vue?vue&type=style&index=0&id=3de10ca8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_ec1e824a4fe600ca080e24d3f05cd390/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de10ca8",
  null
  
)

export default component.exports